import {useNavigate} from "react-router-dom";
import {NumberUtil} from "base/utilities";

import {SectionCardHeaderAction, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import {SisbagalSectionCard} from "sisbagal/auth";

const PoligonoSaneamentoSection = ({poligono}) => {
    const navigate = useNavigate();

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                navigate(`saneamento/edit`);
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Saneamento" secondaryActions={secondaryActions}>
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Grado de ocupación:"
                        value={NumberUtil.formatDecimal2(poligono.grado_ocupacion)}
                        unit="%"
                        tooltipText="Porcentaxe de ocupación da área industrial"
                    />
                    <SectionField
                        label="Superficie:"
                        value={NumberUtil.formatDecimal2(poligono.superficie)}
                        unit="ha"
                        tooltipText="Superficie da área industrial"
                    />
                    <SectionField
                        label="Habitantes equivalentes:"
                        value={NumberUtil.formatDecimalAsInteger(
                            poligono.habitantes_equivalentes
                        )}
                        unit="heq"
                        tooltipText="Carga xerada na área industrial"
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Caudal de saneamento:"
                        value={NumberUtil.formatDecimal2(poligono.caudal_saneamento)}
                        unit="l/s"
                        tooltipText="Caudal vertido a rede de saneamento na área industrial"
                    />
                    <SectionField
                        label="Carga:"
                        value={poligono.carga}
                        unit="mg/l"
                        tooltipText="Carga de materia orgánica das augas residuais xeradas na área industrial"
                    />
                    <SectionField
                        label="Dotación:"
                        value={NumberUtil.formatDecimal2(poligono.dotacion)}
                        unit="l/s / ha"
                        tooltipText="Dotación estimada na área industrial"
                    />
                    <SectionField
                        label="Caudal de abastecemento:"
                        value={NumberUtil.formatDecimal2(poligono.caudal_abastecemento)}
                        unit="l/s"
                        tooltipText="Consumo de auga na área industrial"
                    />
                </Grid>
            </Grid>
        </SisbagalSectionCard>
    );
};

export default PoligonoSaneamentoSection;
